import React from 'react'

export const TeacherNote = ({notes}) => {
  return (
    <div className='card mt-3 shadow-sm'>
    <div className='card-header'>Teacher notes</div>
    <div className='card-body'>
    {notes}
    </div>  
  </div>
  )
}
